// ** Components
import FadeInView from '@/components/common/FadeInView';
import CardCarousel from '@/components/common/carousel/CardCarousel';
import ImageTeaserCard from '@/components/common/ImageTeaserCard';

// ** Types
import type { LightboxItem } from '@/components/common/ImageTeaserCard/ImageLightbox';
import type { ImageCarouselBlockProps } from './ImageCarousel.types';

const ImageCarouselBlock = ({
	items,
	title,
	ctaLabel = 'Alle Bilder',
	ctaHref,
	showOnlyImages
}: ImageCarouselBlockProps) => {
	const lightboxItems: LightboxItem[] = items.map((item) => ({
		src: item?.src,
		alt: item.alt,
		caption: item.caption,
		imageData: item.imageData
	}));

	return (
		<FadeInView>
			<CardCarousel
				items={items}
				getItemKey={(item, index) => `${item.src}-${index}`}
				cardsPerView={{ xs: 1.2, md: 2.3 }}
				renderItem={(item, index) => (
					<ImageTeaserCard
						{...item}
						showOnlyImages={showOnlyImages}
						lightboxItems={lightboxItems}
						lightboxIndex={index}
					/>
				)}
				title={title}
				showTitle={Boolean(title)}
				ctaLabel={ctaLabel}
				ctaHref={ctaHref ?? '#'}
				showCta={Boolean(ctaHref)}
				indicatorCount={3}
				spaceBetween={4}
			/>
		</FadeInView>
	);
};

export default ImageCarouselBlock;
